
import { API_ENDPOINTS } from "../config/api/apiCall";
import { callApi } from "../utils/apiClient";

export const loadEmployeeList = async () => {
    try {
        const payload = {
            p_companyid: localStorage.getItem('companyid') || 0,            
        };

        return await callApi(API_ENDPOINTS.EMPLOYEE_GetEmployeeLists, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};

export const loadEmployeeListByDepartmentID = async (payload) => {
    try {       

        return await callApi(API_ENDPOINTS.HR_SHIFT_EMPLOYEE_LIST_BY_DEPARTMENT, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};


export const loadAllEmployeeList = async () => {
    try {
        const payload = {
            p_companyid: localStorage.getItem('companyid') || 0,            
        };

        return await callApi(API_ENDPOINTS.HR_GET_EMPLOYEE_DETAILS, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};


export const loadGetEmployeeCode = async (payload) => {
    try {       

        return await callApi(API_ENDPOINTS.HR_GET_EMPLOYEE_NUMBER, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};